"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RequestMethod_1 = require("../Components/Http/RequestMethod");
class Http {
    static methodToString(method) {
        switch (method) {
            case RequestMethod_1.default.DELETE:
                return 'DELETE';
            case RequestMethod_1.default.HEAD:
                return 'HEAD';
            case RequestMethod_1.default.OPTIONS:
                return 'OPTIONS';
            case RequestMethod_1.default.PATCH:
                return 'PATCH';
            case RequestMethod_1.default.POST:
                return 'POST';
            case RequestMethod_1.default.PUT:
                return 'PUT';
            case RequestMethod_1.default.GET:
            default:
                return 'GET';
        }
    }
    /**
     * Serialize key/value object to query string
     */
    static toQueryString(obj) {
        return Http.objectToQueryString(null, obj).join('&');
    }
    /**
     * Transform multi dimensional object to FormData obj
     */
    static toFormData(obj, formData) {
        return this.objectToFormData(null, obj, formData !== null && formData !== void 0 ? formData : new FormData());
    }
    /**
     * Convert multidimensional object to FormData recursively
     */
    static objectToFormData(prefix, object, formData) {
        Object.keys(object).forEach((key) => {
            const name = prefix ? prefix + `[${key}]` : key;
            if (object[key] === undefined || object[key] === null) {
                return;
            }
            // add Array and (only) JSON Object recursively. Additional check if it's json object
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (Array.isArray(object[key]) || (typeof object[key] === 'object' && object[key].constructor === ({}).constructor)) {
                Http.objectToFormData(name, object[key], formData);
            }
            else if (object[key] === true) {
                formData.append(name, '1');
            }
            else if (object[key] === false) {
                formData.append(name, '');
            }
            else {
                formData.append(name, object[key]);
            }
        });
        return formData;
    }
    /**
     * Convert multidimensional object to query string
     */
    static objectToQueryString(prefix, object) {
        let result = [];
        Object.keys(object).forEach((key) => {
            const name = prefix ? prefix + encodeURIComponent(`[${key}]`) : key;
            if (object[key] === undefined || object[key] === null) {
                return;
            }
            if (Array.isArray(object[key]) || typeof object[key] === 'object') {
                result = result.concat(Http.objectToQueryString(name, object[key]));
            }
            else if (object[key] === true) {
                result.push(name + '=1');
            }
            else if (object[key] === false) {
                result.push(name + '=');
            }
            else {
                result.push(name + '=' + encodeURIComponent(object[key]));
            }
        });
        return result;
    }
}
exports.default = Http;
//# sourceMappingURL=Http.js.map